import { Dialog } from '@material-ui/core';
import { fade, withStyles } from '@material-ui/core/styles';

export const StyledDialog = withStyles(theme => ({
  paper: {
    backgroundColor: theme.palette.background.container,
    padding: 0,
    border: '1px solid',
    borderColor: fade(theme.palette.text.primary, .5),
  },
}), { name: 'StyledDialog' })(Dialog);
